import React from "react";
import { auth } from "../../firebase"; // Assuming your firebase config is exported from here
import { FAMILY_RELATIONSHIPS } from "../../lib/familyRelationships";
import { ROLES } from "../../lib/rolesConfig";

// Base URL for Cloud Functions API
const API_BASE_URL = `https://asia-southeast1-${process.env.REACT_APP_FIREBASE_PROJECT_ID}.cloudfunctions.net/api`;

const InviteMemberModal = ({
  isOpen,
  onClose,
  careProfileId,
  careProfileName,
  onInviteSent,
}) => {
  if (!isOpen) {
    return null;
  }

  const handleInvite = async (e) => {
    e.preventDefault();
    const currentUser = auth.currentUser;

    if (!currentUser || !careProfileId) {
      console.error("User not logged in or care profile not selected.");
      // Add user-facing error handling here
      return;
    }

    const formData = new FormData(e.target);
    const inviteeEmail = formData.get("email");
    const relationship = formData.get("relationship");
    const role = formData.get("role");

    try {
      const idToken = await currentUser.getIdToken();
      const functionUrl = `${API_BASE_URL}/care-team/send-invitation`; // use the global base-URL

      const response = await fetch(functionUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${idToken}`,
        },
        body: JSON.stringify({
          inviteeEmail,
          relationship,
          role,
          careProfileId,
          careProfileName,
        }),
      });

      if (!response.ok) {
        const errorBody = await response.json();
        throw new Error(errorBody.error || "Failed to send invitation.");
      }

      const result = await response.json();
      console.log("Invitation sent successfully:", result);
      onInviteSent(); // Call the success callback
    } catch (error) {
      console.error("Error sending invitation:", error);
      // Add user-facing error handling here, e.g., show a toast notification
    }
  };

  return (
    <div className="fixed inset-0 z-40 flex h-full w-full items-center justify-center overflow-y-auto bg-gray-600 bg-opacity-50 p-4">
      <div className="relative mx-auto w-full max-w-md rounded-2xl border bg-white p-6 shadow-lg sm:p-8">
        <h3 className="text-2xl font-bold text-gray-800 mb-6">Invite family</h3>
        <form onSubmit={handleInvite}>
          <div className="mb-4">
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Email Address
            </label>
            <input
              type="email"
              id="email"
              name="email"
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
              placeholder="name@example.com"
            />
          </div>

          <div className="mb-4">
            <label
              htmlFor="relationship"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Assign relationship
            </label>
            <select
              id="relationship"
              name="relationship"
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="">Select relationship</option>
              {FAMILY_RELATIONSHIPS.map((relationship) => (
                <option key={relationship} value={relationship}>
                  {relationship}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-6">
            <label
              htmlFor="role"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Assign role
            </label>
            <select
              id="role"
              name="role"
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
            >
              {Object.values(ROLES)
                .filter((role) => role !== ROLES.OWNER)
                .map((role) => (
                  <option key={role} value={role}>
                    {role}
                  </option>
                ))}
            </select>
          </div>

          <div className="flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
            <button
              type="button"
              onClick={onClose}
              className="min-h-11 px-6 py-2 border rounded-lg text-gray-700 hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="min-h-11 px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
            >
              Send invitation
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default InviteMemberModal;
